import { t } from "@lingui/macro";
import { LinearGradient } from "expo-linear-gradient";
import { useSetAtom } from "jotai";
import { Image, Keyboard } from "react-native";

import {
  Box,
  HStack,
  Pressable,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";
import { getFill, getThumbnail } from "@whoosh/utilities/src/Cloudinary";

import { ProceedToWelcomeStepAtom } from "../../../../../atoms/actions";
import { PublicClubSearchResult } from "../hooks/usePublicClubsSearch";

export const ClubSelectionResultItem = ({
  result,
  emailOrPhone,
}: {
  result: PublicClubSearchResult;
  emailOrPhone: string | null;
}) => {
  const bgImageId = result.backgroundImage?.publicId;
  const backgroundImage = getFill(bgImageId, 412, 230)?.toURL();
  const clubLogoPublicId = result.logoImage?.publicId;

  const proceedToWelcome = useSetAtom(ProceedToWelcomeStepAtom);

  const handlePress = () => {
    Keyboard.dismiss();
    proceedToWelcome({
      clubSlug: result.slug,
      emailOrPhone: emailOrPhone ?? undefined,
    });
  };

  return (
    <Pressable onPress={handlePress}>
      <HStack
        alignItems="center"
        gap={2}
        justifyContent="space-between"
        borderWidth={bgImageId ? 0 : 1.5}
        borderColor="surface-dividers"
        borderRadius="4"
        overflow="hidden"
        width="100%"
      >
        {bgImageId ? (
          <Image
            accessible={false}
            source={{ uri: backgroundImage }}
            style={{
              width: "100%",
              height: 120,
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}
            resizeMode="cover"
          />
        ) : null}
        <HStack
          width="100%"
          justifyContent="space-between"
          alignItems="center"
          padding={4}
        >
          {bgImageId ? (
            <LinearGradient
              colors={["rgba(0, 0, 0, 0.15)", "rgba(0, 0, 0, 0.65)"]}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
              }}
            />
          ) : null}
          <VStack justifyContent="space-between">
            <Text
              variant={"mainBaseSemiBold"}
              color={bgImageId ? "text-inverse" : "text-primary"}
            >
              {result.name}
            </Text>
            {result.city && result.state ? (
              <Text variant={"mainSmallMedium"} color="text-secondary">
                {result.city}, {result.state}
              </Text>
            ) : null}
          </VStack>
          {clubLogoPublicId ? (
            <Image
              source={{
                uri: getThumbnail(clubLogoPublicId, 55, 55)?.toURL(),
              }}
              accessibilityLabel={t`${result.name} logo`}
              style={{
                width: 56,
                height: 56,
                borderRadius: 8,
                borderWidth: 2,
                borderColor: "white",
              }}
            />
          ) : (
            <Box width={56} height={56} />
          )}
        </HStack>
      </HStack>
    </Pressable>
  );
};
